import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <header className="bg-light shadow-sm sticky-top">
      <div className="container d-flex justify-content-between align-items-center py-2">
        {/* Left: Logo */}
        <div className="d-flex align-items-center">
          <Link to="/" className="text-decoration-none">
            <h4 className="m-0 fw-bold text-primary">SubCity</h4>
          </Link>
        </div>

        {/* Center: Menu (Desktop) */}
        {/* <nav className="d-none d-md-block">
          <ul className="navbar-nav d-flex flex-row gap-4 mb-0">
            <li className="nav-item">
              <Link className="nav-link fw-medium" to="/">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link fw-medium" to="/#about">About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link fw-medium" to="/#service">Services</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link fw-medium" to="/contact-us">Contact</Link>
            </li>
          </ul>
        </nav> */}

        {/* Right: Contact Support Button + Mobile Menu Button */}
        <div className="d-flex align-items-center gap-2">
          <Link to="/support" className="btn btn-primary btn-sm px-3">
            Contact Support
          </Link>

          {/* Hamburger for Mobile */}
          <button
            className="btn btn-outline-dark d-md-none"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#mobileMenu"
            aria-controls="mobileMenu"
          >
            &#9776;
          </button>
        </div>
      </div>

      {/* Offcanvas Mobile Menu */}
      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="mobileMenu"
        aria-labelledby="mobileMenuLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="mobileMenuLabel">Menu</h5>
          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link className="nav-link" to="/" data-bs-dismiss="offcanvas">Home</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/#about" data-bs-dismiss="offcanvas">About</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/#service" data-bs-dismiss="offcanvas">Services</Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact-us" data-bs-dismiss="offcanvas">Contact</Link>
            </li>
            <li className="nav-item mt-3">
              <Link
                to="/support"
                className="btn btn-primary w-100"
                data-bs-dismiss="offcanvas"
              >
                Contact Support
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default Header;
